import { styled } from '../../Utilities';
import { DialogContentBase } from './DialogContent.base';
import { getStyles } from './DialogContent.styles';
export var DialogContent = styled(DialogContentBase, getStyles, undefined, {
  scope: 'DialogContent'
});
DialogContent.displayName = 'DialogContent';